import { computed, makeObservable, observable } from 'mobx';
import { Notify } from '@shared/ui-native/Notify';
import { Ajax, Ajax2 } from '@shared/Ajax';


export class ProjectPropertyJsonArrayStore<T extends { n?: string, t: string, readOnly?: boolean }> {
    @observable itemsEditable: T[] = [];
    @observable itemsReadonly: T[] = [];
    @observable allItems: T[] = [];

    @observable asyncState = {
        isInitialLoad: true,
        isFetching: true,
        isAdding: false
    };

    @computed
    get isDoingAsyncWork(): boolean {
        return this.asyncState.isFetching || this.asyncState.isAdding;
    }

    @computed
    get hasItems(): boolean {
        return (this.itemsEditable.length + this.itemsReadonly.length) > 0;
    }

    constructor(private projectPropertyKey: string) {
        makeObservable(this);
    }

    fetch() {
        this.asyncState.isFetching = true;
        return Ajax({
            url: `api/1/project/${kuura.getProjectUuid()}/property/${this.projectPropertyKey}`
        }).then(resp => {
            if (resp.projectProperty?.value) {
                const items: T[] = JSON.parse(resp.projectProperty?.value);
                this.allItems = items;
                this.itemsEditable = items.filter(l => !l.readOnly);
                this.itemsReadonly = items.filter(l => l.readOnly);
            }
        })
        .always(() => {
            this.asyncState.isFetching = false;
            this.asyncState.isInitialLoad = false;
        });
    }

    deleteItem = (index: number) => {
        const item = this.itemsEditable[index]

        if (confirm(kuura.getMessage('general.confirm_delete', item.n || item.t))) {
            this.asyncState.isFetching = true;
            this.itemsEditable.splice(index, 1);
            return this.saveList();
        }
    }

    saveList = () => {
        const templates = [...this.itemsReadonly, ...this.itemsEditable];
        this.asyncState.isAdding = true;

        return Ajax2({
            url: kuura.getContextPath() + `/api/1/project/${kuura.getProjectUuid()}/property`,
            method: 'POST',
            contentType: 'json',
            data: {
                projectId: kuura.getProjectId(),
                key: this.projectPropertyKey,
                value: JSON.stringify(templates)
            }
        }).then(() => {
            this.fetch();
            Notify.success();
        }).catch(resp => {
            if (resp.errorMessages && resp.errorMessages.length > 0) {
                for (const errormessage of resp.errorMessages) {
                    Notify.error(kuura.getMessage(errormessage));
                }
            } else if (resp && resp.errors && resp.errors.includes('403')) {
                Notify.error(kuura.getMessage('general.validation.access_not_allowed'));
            } else {
                Notify.error();
            }
        }).finally(() => {
            setTimeout(() => {
                this.asyncState.isAdding = false;
            }, 500);
        });
    }
}
